import { StringProperty } from ".";

export class UrlProperty extends StringProperty {
  // TODO: validation prolly.
}
